import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  preprocessTextAsyncAutocompleteField,
  dateSchema,
  parseToDateValue,
} from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby code
export const categoryOptions = [
  { value: "fxf", label: "Fxf" },
  { value: "fut", label: "Fut" },
  { value: "opt", label: "Opt" },
  { value: "div", label: "Div" },
  { value: "fee", label: "Fee" },
  { value: "cash", label: "Cash" },
  { value: "cash_as_value", label: "Cash as Value" },
  { value: "agg_div", label: "Agg Div" },
  { value: "interest", label: "Interest" },
  { value: "transfer", label: "Transfer" },
  { value: "incoming_delivery", label: "Incoming Delivery" },
  { value: "tax", label: "Tax" },
];

export const filterTransactionsSchema = z.object({
  strategy_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  category_contains: z.string().nullable().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterTransactionsSchema = z.infer<typeof filterTransactionsSchema>;

export const fields: Field[] = [
  {
    name: "strategy_id_contains",
    label: "Strategy",
    type: "asyncAutocomplete",
    base_url: "legacy-quantilia/strategies",
    column_name: "name",
    id_column: "id",
  },
  {
    name: "category_contains",
    label: "Category",
    type: "select",
    useTranslation: false,
    options: categoryOptions,
  },
  {
    name: "date_from",
    label: "Date From",
    type: "date",
  },
  {
    name: "date_to",
    label: "Date To",
    type: "date",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
];

export const client = "legacy-quantilia";

export function FilterTransactions() {
  return (
    <FilterTable
      client={client}
      schema={filterTransactionsSchema}
      tableName="transactions"
      customBuildPath={() => `${client}/transactions`}
      fields={fields}
    />
  );
}
